export function getContextVariables() {
    const params = new URLSearchParams(window.location.search);  
    let variables: { [key: string]: string } = {};  
        
    params.forEach((value, key) => {  
        if (key.startsWith('context[') && key.endsWith(']')) {  
            let newKey = key.slice(8, -1); 
            variables[newKey] = value;  
        }  
    }); 

    return variables;
}